import { toast } from '@hivebrite/design-system/Toast';

const handleDisplayErrorToast = (response) => {
  let message;

  if (response instanceof ReferenceError) {
    message = response?.message;
  } else {
    message = response?.response?.data;
  }

  toast.error(message);
};

export default handleDisplayErrorToast;
